'use client';

import type { Path } from '@ahm/api-wrappers-core';
import { rem } from '@mantine/core';
import { openContextModal } from '@mantine/modals';
import type { PathInfo } from './types';
import type { UpdateStopInfoRequest } from '@/api/order';
import { ModalName } from '@/components/modals';

interface OpenEditPathInfoModalProps {
  paths: Path[];
  isPickup: boolean;
  onSave?: (data: PathInfo) => void;
}

export function openEditPathInfoModal({
  paths,
  isPickup,
  onSave,
}: OpenEditPathInfoModalProps) {
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

  openContextModal({
    modal: ModalName.EditPathInfo,
    id: ModalName.EditPathInfo,
    innerProps: {
      paths,
      isPickup,
      onSave,
    },
    size: isMobile ? '100%' : rem(500),
    centered: true,
    fullScreen: isMobile,
    withCloseButton: false,
    styles: {
      body: {
        position: 'relative',
        padding: 0,
      },
    },
  });
}

export function mapSenderPath(
  senderPath: Path,
  pickup: UpdateStopInfoRequest['pickup']
): Path {
  return {
    ...senderPath,
    name: pickup.name,
    mobile: pickup.mobile,
    remarks: pickup.remarks,
  };
}

export function mapRecipientPath(
  recipientPath: Path,
  dropoff: UpdateStopInfoRequest['dropoffs'][0]
): Path {
  return {
    ...recipientPath,
    lat: dropoff.lat,
    lng: dropoff.lng,
    name: dropoff.name,
    mobile: dropoff.mobile,
    address: dropoff.address,
    remarks: dropoff.remarks,
    cod: dropoff.cod,
  };
}
